import { useState } from "react";
import emailjs from "emailjs-com";
import React from "react";
import { ToastContainer, toast } from 'react-toastify';
import { sendContactNotificationToSlack } from '../utils/slackNotification';
import SlackNotificationTest from './common/SlackNotificationTest';
import InterviewScheduler from './InterviewScheduler';

const initialState = {
  name: "",
  email: "",
  message: "",
  contactType: "message",
};

export const Contact = (props) => {
  const [{ name, email, message, contactType }, setState] = useState(initialState);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showInterviewScheduler, setShowInterviewScheduler] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };
  
  const clearState = () => setState({ ...initialState });

  // PDFダウンロード関数（より確実な実装）
  const downloadPDF = async () => {
    try {
      const pdfUrl = "/pdf/company-brochure.pdf";
      
      // まずPDFファイルが存在するかチェック
      const response = await fetch(pdfUrl, { method: 'HEAD' });
      
      if (!response.ok) {
        throw new Error('PDF file not found');
      }

      // ダウンロード実行
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.download = "DeepTeLL_会社案内.pdf";
      link.target = '_blank'; // 新しいタブで開く
      
      // リンクをDOMに追加してクリック、その後削除
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      
      return true;
    } catch (error) {
      console.error('PDF download failed:', error);
      
      // フォールバック: 新しいタブでPDFを開く
      try {
        window.open("/pdf/company-brochure.pdf", '_blank');
        return true;
      } catch (fallbackError) {
        console.error('PDF fallback failed:', fallbackError);
        toast.error("PDFファイルのダウンロードに失敗しました。しばらく後でもう一度お試しください。");
        return false;
      }
    }
  };

  // Timerex面談調整関数
  const openTimerex = () => {
    try {
      const timerexUrl = "https://timerex.net/s/info_cd2f_c601/b4f221be";
      
      // 新しいタブで開く（より確実）
      const newWindow = window.open(timerexUrl, '_blank', 'noopener,noreferrer');
      
      if (!newWindow) {
        // ポップアップがブロックされた場合の対処
        toast.warning("ポップアップがブロックされました。以下のリンクから面談調整ページにアクセスしてください。");
        console.log("Timerex URL:", timerexUrl);
        
        // フォールバック: 現在のタブで開く
        window.location.href = timerexUrl;
      } else {
        toast.success("面談調整ページを新しいタブで開きました。");
      }
      
      return true;
    } catch (error) {
      console.error('Timerex open failed:', error);
      toast.error("面談調整ページの表示に失敗しました。");
      return false;
    }
  };
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    console.log(name, email, message, contactType);

    try {
      if (contactType === "meeting") {
        // 面談調整の場合はカレンダーUIを表示
        if (!name || !email) {
          toast.error("面談調整には、お名前とメールアドレスの入力が必要です");
          return;
        }
        
        setShowInterviewScheduler(true);
        return;
      }
      
      if (contactType === "download") {
        // PDFダウンロード処理
        const downloadSuccess = await downloadPDF();
        
        if (downloadSuccess) {
          // 1. Slack通知送信（ダウンロード）
          try {
            const downloadData = {
              name: name || "未入力",
              email: email || "未入力",
              company: "",
              phone: "",
              message: "会社案内資料をダウンロードしました"
            };
            
            await sendContactNotificationToSlack(downloadData, 'materials');
            console.log('✅ Slack download notification sent');
          } catch (slackError) {
            console.warn('⚠️ Slack download notification failed:', slackError);
          }

          // 2. EmailJS送信（ダウンロードログ）
          try {
            const emailData = {
              to_email: "info@deeptell.jp",
              user_name: name || "未入力",
              user_email: email || "未入力",
              download_type: "会社案内資料",
              download_time: new Date().toLocaleString("ja-JP"),
              message: `${name || "未入力"}様が会社案内資料をダウンロードしました。`
            };

            await emailjs.send(
              "service_tl9faat", 
              "template_download",
              emailData,
              "hezeixpMbUL6iyGuw"
            );
            console.log('✅ Download email notification sent');
          } catch (emailError) {
            console.warn('⚠️ Download email notification failed:', emailError);
          }
          
          toast.success("資料ダウンロードが完了しました");
        }
        
        clearState();
        return;
      }
      
      // 通常のメッセージ送信の場合
      if (contactType === "message") {
        // 1. Slack通知送信
        try {
          const slackData = {
            name: name || "未入力",
            email: email || "未入力",
            company: "",
            phone: "",
            message: message || ""
          };
          
          await sendContactNotificationToSlack(slackData, 'general');
          console.log('✅ Slack message notification sent');
        } catch (slackError) {
          console.warn('⚠️ Slack message notification failed:', slackError);
        }

        // 2. EmailJS送信（通常のお問い合わせ）
        try {
          const emailData = {
            to_email: "info@deeptell.jp",
            from_name: name,
            from_email: email,
            message: message,
            reply_to: email,
            subject: `DeepTeLL Webサイトからのお問い合わせ - ${name}様`,
            sent_time: new Date().toLocaleString("ja-JP")
          };
          
          await emailjs.send(
            "service_tl9faat", 
            "template_sc0e9mr", 
            emailData,
            "hezeixpMbUL6iyGuw"
          );
          console.log('✅ Email message notification sent');
        } catch (emailError) {
          console.warn('⚠️ Email message notification failed:', emailError);
        }

        toast.success("お問い合わせを送信しました。担当者からご連絡いたします。");
        clearState();
      }

    } catch (error) {
      console.error('Form submission error:', error);
      toast.error("送信に失敗しました。しばらく後でもう一度お試しください。");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div>
      {/* Slack通知テストボタン（開発環境のみ） */}
      <SlackNotificationTest />
      
      <ToastContainer 
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      /> 
      <div id="contact">
        <div className="container">
          <div className="col-md-8">
            <div className="row">
              <div className="section-title">
                <h2>お問い合わせ</h2>
                <p>
                   下記のフォームにご記入の上、メールをお送りください。
                </p>
              </div>
              <form name="sentMessage" validate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="text"
                        id="name"
                        name="name"
                        className="form-control"
                        placeholder="お名前"
                        required={contactType === "message"}
                        value={name}
                        onChange={handleChange}
                        disabled={isSubmitting}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        id="email"
                        name="email"
                        className="form-control"
                        placeholder="メールアドレス"
                        required={contactType === "message"}
                        value={email}
                        onChange={handleChange}
                        disabled={isSubmitting}
                      />
                      <p className="help-block text-danger"></p>
                    </div>
                  </div>
                </div>
                <div className="form-group">
                  <select
                    name="contactType"
                    id="contactType"
                    className="form-control"
                    required
                    value={contactType}
                    onChange={handleChange}
                    disabled={isSubmitting}
                  >
                    <option value="message">お問い合わせ</option>
                    <option value="download">資料ダウンロード</option>
                    <option value="meeting">面談調整</option>
                  </select>
                  <p className="help-block text-danger"></p>
                </div>
                {contactType === "message" && (
                  <div className="form-group">
                    <textarea
                      name="message"
                      id="message"
                      className="form-control"
                      rows="4"
                      placeholder="お問い合わせ内容"
                      required
                      value={message}
                      onChange={handleChange}
                      disabled={isSubmitting}
                    ></textarea>
                    <p className="help-block text-danger"></p>
                  </div>
                )}
                {contactType === "download" && (
                  <div className="form-group" style={{ padding: "20px", background: "rgba(59, 130, 246, 0.1)", borderRadius: "8px", border: "1px solid rgba(59, 130, 246, 0.3)" }}>
                    <h4 style={{ color: "#3b82f6", marginBottom: "15px" }}>会社案内資料</h4>
                    <p style={{ color: "#cbd5e1", marginBottom: "15px" }}>
                      DeepTeLL の事業内容、技術力、実績についてまとめた資料をダウンロードいただけます。
                    </p>
                    <ul style={{ color: "#94a3b8", marginLeft: "20px" }}>
                      <li>• 会社概要・事業内容</li>
                      <li>• 技術紹介・特徴</li>
                      <li>• 導入事例・実績</li>
                      <li>• サービス一覧</li>
                    </ul>
                  </div>
                )}
                {contactType === "meeting" && (
                  <div className="form-group" style={{ padding: "20px", background: "rgba(16, 185, 129, 0.1)", borderRadius: "8px", border: "1px solid rgba(16, 185, 129, 0.3)" }}>
                    <h4 style={{ color: "#10b981", marginBottom: "15px" }}>面談調整</h4>
                    <p style={{ color: "#cbd5e1", marginBottom: "15px" }}>
                      担当者との面談をご希望の方は、専用の調整ページで日程をお選びいただけます。
                    </p>
                    <ul style={{ color: "#94a3b8", marginLeft: "20px" }}>
                      <li>• オンライン面談（30分〜1時間）</li>
                      <li>• サービス詳細説明</li>
                      <li>• 質疑応答・相談</li>
                      <li>• 導入支援について</li>
                    </ul>
                  </div>
                )}
                <div id="success"></div>
                <button 
                  type="submit" 
                  className="btn btn-custom btn-lg"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "処理中..." : (
                    <>
                      {contactType === "message" && "送信"}
                      {contactType === "download" && "資料ダウンロード"}
                      {contactType === "meeting" && "面談調整ページを開く"}
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Contact Info</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Address
                </span>
                {props.data ? props.data.address : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Phone
                </span>{" "}
                {props.data ? props.data.phone : "loading"}
              </p>
            </div>
            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>{" "}
                {props.data ? props.data.email : "loading"}
              </p>
            </div>
          </div>
          <div className="col-md-12">
            <div className="row">
              <div className="social">
                <ul>
                  <li>
                    <a href={props.data ? props.data.facebook : "/"}>
                      <i className="fa fa-facebook"></i>
                    </a>
                  </li>
                  <li>
                    <a href={props.data ? props.data.twitter : "/"}>
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="footer">
        <div className="container text-center">
          <p>
            &copy; 2024 All Rights Reserved by{" "}
            <a href="https://deeptell.co.jp" rel="nofollow">
              DeepTeLL
            </a>
          </p>
        </div>
      </div>
      
      {/* 面接調整カレンダーモーダル */}
      {showInterviewScheduler && (
        <InterviewScheduler
          formData={{ name, email }}
          onClose={() => {
            setShowInterviewScheduler(false);
            clearState();
          }}
        />
      )}
    </div>
  );
};
